import React, { useMemo } from 'react'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import ProductPaletteProvider from 'contexts/ProductPaletteContext'
import LuxPlusHiddenOfferLabel from './LuxPlusHiddenOfferLabel'
import { useOfferPackagePrice } from 'hooks/Offers/useOfferPrice'
import { getThemeClassName } from 'lib/theme/themeUtils'
import useHiddenOfferClickHandler from './useHiddenOfferClickHandler'
import OfferLabels from 'components/Common/Labels/OfferLabels'
import { earlyAccessRestrictedToMembers } from 'luxPlus/lib/utils'
import Colour from 'components/utils/Colour'

interface Props {
  offer: App.Offer | App.OfferSummary
  urgencyLabels?: Array<App.OfferUrgencyLabel>
}

function LuxPlusHiddenOfferDetails(props: Props) {
  const {
    offer,
    urgencyLabels,
  } = props
  const onHandleHiddenOffer = useHiddenOfferClickHandler(offer)

  const pkg = offer.lowestPricePackage!
  const {
    valueOffPercent,
  } = useOfferPackagePrice(pkg, offer, { showMemberPrice: true })

  /**
   * If the locationHeading and locationSubheading are the same, only display the locationSubheading
   * e.g. Singapore, Singapore -> Singapore
  */
  const formattedLocationHeading = useMemo(() => {
    if (offer.locationHeading === offer.locationSubheading) return offer.locationSubheading
    return `${offer.locationHeading}, ${offer.locationSubheading}`
  }, [offer.locationHeading, offer.locationSubheading])

  return <Group gap={16} direction="vertical" verticalAlign="space-between">
    <VerticalSpacer gap={8}>
      {!earlyAccessRestrictedToMembers(offer) && <LuxPlusHiddenOfferLabel className={getThemeClassName({ mobile: 'inverse' })} />}
      {earlyAccessRestrictedToMembers(offer) &&
        <OfferLabels
          offer={offer}
          urgencyLabels={urgencyLabels}
        />}
      <Heading variant="heading5">
        <Colour value="highlight-secondary">Members save up to {valueOffPercent}%</Colour>
        {' '}on this hidden offer in {formattedLocationHeading}
      </Heading>
    </VerticalSpacer>

    <div>
      <ProductPaletteProvider palette="lux-plus">
        <TextButton
          variant="default"
          kind="secondary"
          onClick={onHandleHiddenOffer}
        >
          Unlock this offer via Free Preview
        </TextButton>
      </ProductPaletteProvider>
    </div>
  </Group>
}

export default LuxPlusHiddenOfferDetails
